import { render } from "./RegistrationSite.vue?vue&type=template&id=160280be"
import script from "./RegistrationSite.vue?vue&type=script&lang=js"
export * from "./RegistrationSite.vue?vue&type=script&lang=js"

import exportComponent from "/home/parmcoder/muic/Deguild-Project/deguild-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__